import { createFileRoute } from '@tanstack/react-router';
import { SnapshotAdminList } from '@features/snapshot-admin/SnapshotAdminList';
import { validateTableSearch } from '@utils/tabHelpers';

export const Route = createFileRoute('/w/contracts/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'createdOn', sortDir: 'desc', tab: 'IN_REVIEW' }),
  component: ContractsPage,
});

function ContractsPage() {
  const searchParams = Route.useSearch();
  return <SnapshotAdminList searchParams={searchParams} />;
}
